import { render, staticRenderFns } from "./parkas.vue?vue&type=template&id=7cf79554&scoped=true&"
import script from "./parkas.vue?vue&type=script&lang=js&"
export * from "./parkas.vue?vue&type=script&lang=js&"
import style0 from "./parkas.vue?vue&type=style&index=0&id=7cf79554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf79554",
  null
  
)

export default component.exports